import AdminLayout from "components/layouts/AdminLayout";
import SingleLoanViewLayout from "components/tenders/singleLoan/SingleLoanViewLayout";
import { useLocation, useNavigate, useParams } from 'react-router';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { TranslateString, convertToObjectKeyString } from "Utils/Common";
import { message, Modal } from "antd";
import { useState, useEffect } from "react";
import LoanOfferComparison from "components/tenders/singleLoan/LoanOfferComparison";
import SingleLoanServices from "services/services/SingleLoanServices";
import { useIntl } from 'react-intl';
import CompanyInformationServices from 'services/services/CompanyInformationServices';

var htmlPdfClient = require("html-pdf-client")

function SingleLoanView(props: any) {
    const navigate = useNavigate();
    const location = useLocation();
    const id:any = useParams();
    const [btnClick, setBtnClick] = useState<any>((id?.loan_comparision_tab==2?2:1));
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [btnState, setBtnState] = useState<any>();
    const [disableBtn, setDisableBtn] = useState(false);
    const [showPrintBtn, setPrintShowBtn] = useState(false);
    const [headerText, setHeaderText] = useState('');
    // const [loanData, setLoanData] = useState<any>();
    const intl=useIntl();
    const [printBtn, setPrintBtn] = useState(false);
    const [sendHRrequest, setSendHRrequest] = useState(false);
    const [externalCustomer, setExternalCustomer] = useState<any>(false);
    const [tenderCase, setTenderCase] = useState<any>("open");

    const handleOk = () => {
        if (id) navigate('/end-tendering/' + id.loan_tender_id);
    }

    useEffect(()=>{
        getLoanData();
        getCustomerDetails();
        if(location.state){
            sessionStorage.setItem('single-loan-view',JSON.stringify(location));
            setTenderCase(location?.state?.tender_case || "open")
        }else{
            let tempLocation:any =sessionStorage.getItem('single-loan-view');
            tempLocation = JSON.parse(tempLocation);
            if(location?.pathname===tempLocation?.pathname) {
                setTenderCase(tempLocation?.state?.tender_case || "open")
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const getLoanData = () => {
        setLoading(true);
        let paramsId = id.loan_tender_id
        SingleLoanServices
            .getSingleLoanData(paramsId)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    const responseVal = response?.data?.data
                    // setLoanData(responseVal)
                    setHeaderText(responseVal.LOAN_DATA.loan_data_customername.trim() + ', ' +responseVal.LOAN_DATA.loan_data_name.trim())
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    };
    const handleServiceHm = () => {
        let obj: any = {}
        obj.customer_id = id?.id;

            setLoading(true);
            SingleLoanServices
            .updateHmService(obj,id?.loan_tender_id)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    // SingleLoanViewLayout?.call(getLoanData)
                    setSendHRrequest(true);
                    message.success(intl.formatMessage({id: convertToObjectKeyString('service_request_sent_to_hm')}));
                    setOpen(false)
                    setLoading(false);
                } else if(response?.data?.code === 500){
                    message.error(intl.formatMessage({id: convertToObjectKeyString('service_request_is_failed')}));
                    setLoading(false);
                }
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    }

    const handleCancelPop = () => {
        setOpen(false);
    };

    const print = async () => {
        var element: any = document.getElementById('loan-offer-comparison');
        setPrintBtn(true);

        var opt = {
            margin: 0.1,
            filename: 'Lainavertailu '+ headerText + '.pdf',
            image: { type: 'jpeg', quality: 3 },
            html2canvas: { scale: 3.6 },
            jsPDF: { unit: 'pt', format: 'A4', orientation: 'landscape', compressPDF: true },
            pagebreak: { mode: 'avoid-all', before: '.page-break' }
        };
        setPrintShowBtn(true);
        // New Promise-based usage:
        await htmlPdfClient().set(opt).from(element).save();
        setPrintBtn(false);
        setPrintShowBtn(false);
    }

    const getCustomerDetails = async () => {
        let object:any = {};
        object.customer_id= id?.id;
        await CompanyInformationServices
        .getCustomerData(object)
        .then((response:any) => {
            if(response?.data?.code===200){
                if(response?.data?.loan_data){
                    response?.data?.loan_data.map((item:any) => {
                        if(item?.loan_data_priority && item?.loan_data_priority == '13'){
                            setExternalCustomer(true);
                        }
                    })
                }
            }
        })
        .catch((err:any) => {
           console.log(err)
        });
    }

    return (
        <AdminLayout>
            <div className="ant-card ant-card-bordered cu-mb-10 cu-px-10 w-100 text-left cu-tab-text">
                <Link to={`/tenders`}>
                    <h4 className="cu-m-0 cu-p-0">
                        <button className="ant-btn cu-border-0 back-btn text-primary"><FaArrowLeft style={{ fontWeight: 900, fontSize: '18px' }} /></button>
                        &nbsp;
                        {btnClick === 2 ? <button className="ant-btn cu-border-0 h4 pl-0 align-middle mb-0">{TranslateString('loan_comparison')}: {headerText?.replace('Uusi laina:',TranslateString('new_loan'))}</button>:
                        btnClick === 1 && <button className="ant-btn cu-border-0 h4 pl-0 align-middle mb-0">{TranslateString('single_loan_view_moderator')}</button> }
                    </h4>
                </Link>
            </div>
            <div className="cu-table-small cu-card-padding">
                <div className="d-flex flex-row justify-space-between">

                    <button onClick={() => { setBtnClick(1) }} className={btnClick === 1 ? "btn btn-sm cu-btn-green mr-3 cu-btn-sm-with" : "btn btn-sm cu-btn-green mr-3 opacity-25 cu-btn-sm-with"}>{TranslateString('tender_details')}</button>
                    <button onClick={() => { setBtnClick(2) }} className={btnClick === 2 ? "btn btn-sm cu-btn-green cu-btn-sm-with" : "btn btn-sm cu-btn-green mr-3 opacity-25 cu-btn-sm-with"}>{TranslateString('loan_comparison')}</button>
                       
                    {
                        <div className="ms-auto">
                            <button onClick={() => {
                                setOpen(true)
                                setBtnState("end")
                            }} className={"btn btn-sm btn-danger text-white cu-btn-md-with"} disabled={disableBtn}>{TranslateString('end_tendering')}</button>&nbsp;&nbsp;
                            {btnClick === 2 && <><button onClick={() => { print(); }} className={"btn btn-sm cu-btn-green cu-btn-md-with"}>{TranslateString('export_loan_comparison')}</button>&nbsp;&nbsp;</>}
                            <button 
                                className={"btn btn-sm cu-btn-green cu-btn-md-with"} 
                                onClick={() => {
                                    if(!externalCustomer){
                                        setBtnState("hm")
                                        setOpen(true)
                                    }else {
                                        message.error("This is disabled for external customer.");
                                    }
                                }}
                                disabled={tenderCase==="close" ? true:false}
                            >{TranslateString('send_services_request_to_hm')}</button>
                        </div>
                    }

                </div>
                {btnClick === 1 &&
                    <SingleLoanViewLayout {
                        ...{ ...props, ...id ,tenderCase}}
                        setDisableBtn={setDisableBtn}
                        type={`admin`}
                        setSendHRrequest={setSendHRrequest}
                        sendHRrequest={sendHRrequest}
                    />}
                {btnClick === 2 && <div id="loan-offer-comparison"><LoanOfferComparison {...{ ...props, ...id, tenderCase }} printBtn={printBtn} headerText={headerText} printShow={showPrintBtn}/></div>}
            </div>
            <Modal
                title=""
                open={open}
                onOk={()=>{
                    btnState === "end" ? handleOk() : handleServiceHm()
                }
                }
                okButtonProps={{ className: 'cu-bg-green rounded' }}
                okText={TranslateString('yes')}
                cancelText={TranslateString('no')}
                cancelButtonProps={{ className: 'cu-bg-green rounded' }}
                onCancel={handleCancelPop}
                confirmLoading={loading}
            >
                <p className='h5'>{btnState === "end" ? TranslateString('are_you_sure_you_want_to_end_this_tender') : TranslateString('are_you_sure_you_want_to_send_service_request_to_hm')}</p>
            </Modal>
        </AdminLayout>
    );
}

export default SingleLoanView;